import {parseDateWithFormat} from '@shared/dateUtils';

/**
 * @link https://www.figma.com/design/AhHLTF7ki28EaFSn24Mvr6/07.-%EC%84%9C%EC%9A%B8%EC%8B%9C-%EB%A7%88%EC%9D%BC%EB%A6%AC%EC%A7%80-%EC%97%B0%EA%B3%84?node-id=12176-17306&m=dev
 * 표출 기준
 * 25.01.01 이후 마일리지 가입자 대상으로 표출
 * 서울시 동의 API의 ‘created_at’(최초 등록일)이 25.01.01. 이후
 * 제한 주행거리 업데이트 중 상태에만 표출
 */
const MIDWAY_REGISTRATION_CREATED_AT_THRESHOLD = new Date(2025, 0, 1);

export function getIsMidwayPerformanceRegistrationVisible(userCreatedAt: string) {
  const userCreatedDate = parseDateWithFormat(userCreatedAt);
  return userCreatedDate && userCreatedDate >= MIDWAY_REGISTRATION_CREATED_AT_THRESHOLD;
}

export function getIsRegistrationRequired(middleRgsYn: string) {
  return middleRgsYn === '01';
}
